import {
  INPROCESS_STATUS,
  LOADING_ORDER_STATUS,
  PACKAGING_TYPE,
  PALLET_TYPE,
  PREPARE_DOCUMENT_STATUS,
  PRODUCT_TYPE,
} from "common";
import {
  EInProcessCheckStatus,
  ELoadingOrderStatus,
  EPackagingType,
  EPalletType,
  EPrepareStatus,
  EProductType,
} from "model";
import { I18nTranslator } from "utils/i18n";

export const isStringArray = (test: any[]): boolean => {
  return (
    Array.isArray(test) && test.every((value) => typeof value === "string")
  );
};

export const isBlobString = (text: string): boolean => {
  const blob = new Blob([text]);
  return blob instanceof Blob;
};

export const getProductTypeName = (type: EProductType) => {
  const translate = PRODUCT_TYPE.find((element) => element.type === type)
    ?.name!;
  return translate ? I18nTranslator(translate) : "";
};

export const getPalletTypeName = (type: EPalletType) => {
  const translate = PALLET_TYPE.find((element) => element.type === type)?.name!;
  return translate ? I18nTranslator(translate) : "";
};

export const getPalletQuantName = (type: EPalletType) => {
  const translate = PALLET_TYPE.find((element) => element.type === type)?.name!;
  return translate ? I18nTranslator(translate) : "";
};

export const getProductPackagingName = (type: EPackagingType) => {
  const translate = PACKAGING_TYPE.find((element) => element.type === type)
    ?.name!;
  return translate ? I18nTranslator(translate) : "";
};

export const getLoadingOrderStatusName = (type: ELoadingOrderStatus) => {
  const translate = LOADING_ORDER_STATUS.find(
    (element) => element.type === type
  )?.name!;
  return translate ? I18nTranslator(translate) : "";
};

export const getPrepareStatusName = (type: EPrepareStatus) => {
  const translate = PREPARE_DOCUMENT_STATUS.find(
    (element) => element.type === type
  )?.name!;
  return translate ? I18nTranslator(translate) : "";
};

export const getInProcessStatusName = (type: EInProcessCheckStatus, lang?: string) => {
  const translate = INPROCESS_STATUS.find((element) => element.value === type)
    ?.title!;
  return translate ? I18nTranslator(translate, {lng: lang}) : "";
};
